import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies, no-restricted-imports
import $ from 'jquery';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { Util } from 'app/scripts/lib/util';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { ListList } from 'app/src/components/ListList';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const openListComposer = function (this: any) {
  return this.model.viewState.openListComposer();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const scrollToList = function (this: any, list: any) {
  const viewForList = this.viewForList(list);
  if (viewForList) {
    Util.scrollElementIntoView(
      this.el.querySelector('#board'),
      viewForList.el,
      {
        horizontal: true,
        animated: true,
      },
    );
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const viewForList = function (this: any, list: any) {
  return this.listListView.viewForModel(list);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postListListRender = function (this: any) {
  this.renderFilteringStatus();
  return DragSort.refreshListCardSortable();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderLists = function (this: any) {
  if (this.listRenderingMode === 'react') {
    const mountPoint = $('.js-list-container', this.$el);
    this.unmountLists = renderComponent(
      <ListList
        idBoard={this.model.get('id')}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToCard={(id) => {
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
          Controller.showCardDetail(this.modelCache.get('Card', id));
        }}
      />,
      mountPoint[0],
    );
  } else {
    this.listListView.$el.toggleClass(
      'js-list-sortable',
      this.model.editable(),
    );
    $('.board-canvas', this.$el).append(this.listListView.el);
    // Render after adding because postListListRender is dumb and wants the
    // #board element to be in the DOM already
    this.listListView.render();
    this.listListView.delegateEvents();
  }

  return this;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortCommit = (e: any, ui: any) => ui.item.trigger('movelist', ui);
